(function () {
  if (window.__mpnPdpBack) return; window.__mpnPdpBack = true;
  var FALLBACK = window.__mpnPdpBackCfg.f, LBL = window.__mpnPdpBackCfg.l;
  var mq = window.matchMedia('(max-width: 749.98px)');
  function fromSite() {
    try { return !!document.referrer && new URL(document.referrer).host === location.host && history.length > 1; } catch (e) { return false; }
  }
  function place() {
    if (!mq.matches) return;
    var g = document.querySelector('media-gallery');
    if (!g) return;
    var host = g.querySelector('slider-component') || g;
    host.classList.add('mpn-badges-host');
    var a = host.querySelector(':scope > .mpn-pdp-back');
    if (!a) {
      a = document.createElement('a');
      a.className = 'mpn-pdp-back';
      a.href = FALLBACK;
      a.setAttribute('aria-label', LBL);
      a.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 12H5M11 18l-6-6 6-6"/></svg>';
      a.addEventListener('click', function (e) { if (fromSite()) { e.preventDefault(); history.back(); } });
      host.appendChild(a);
    }
    /* meme taille et meme hauteur que la loupe, en miroir a gauche */
    var hr = host.getBoundingClientRect();
    /* loupe de la photo AFFICHEE (chaque photo a sa loupe : celle de la 1re sort de l'ecran quand on fait defiler) */
    var z = null, zr = null;
    [].some.call(host.querySelectorAll('.product__media-icon'), function (el) {
      var r = el.getBoundingClientRect();
      /* seulement une loupe calee a droite de l'ecran (pendant le glissement, la loupe de la photo suivante passe au milieu :
         avant, la fleche et les badges suivaient et sautaient) */
      if (r.width && r.right <= hr.right + 1 && hr.right - r.right < 40) { z = el; zr = r; return true; }
      return false;
    });
    if (z) {
      if (hr.width) {
        host.style.setProperty('--mpn-bk-s', Math.round(zr.width) + 'px');
        host.style.setProperty('--mpn-bk-t', Math.round(zr.top - hr.top) + 'px');
        host.style.setProperty('--mpn-bk-l', Math.round(hr.right - zr.right) + 'px');
      }
    }
    /* badges : sur la ligne de la fleche, juste a sa droite */
    var b = host.querySelector(':scope > .product__badges.mpn-badges-float');
    var ar = a.getBoundingClientRect();
    if (b && ar.width) {
      var br = b.getBoundingClientRect();
      host.style.setProperty('--mpn-bd-l', Math.round(ar.right - hr.left + 8) + 'px');
      host.style.setProperty('--mpn-bd-t', Math.round(ar.top - hr.top + (ar.height - (br.height || ar.height)) / 2) + 'px');
      b.classList.add('mpn-bd-next');
    }
  }
  /* tout de suite (avant le 1er affichage : pas de saut du titre), puis une fois la page prete */
  try { place(); } catch (e) {}
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place);
  window.addEventListener('load', place);
  [300, 1300, 2500].forEach(function (ms) { setTimeout(place, ms); });
  window.addEventListener('resize', function () { setTimeout(place, 150); });
  document.addEventListener('change', function () { setTimeout(place, 1100); }, true);

  /* Photos : la suivante est deja chargee quand on fait glisser (avant : chargement seulement en arrivant dessus,
     photo vide puis apparition). On charge 2 photos d'avance, puis le reste quand la page est au repos. */
  function warm(n) {
    var ul = document.querySelector('media-gallery .product__media-list');
    if (!ul) return;
    var items = ul.querySelectorAll(':scope > .product__media-item');
    var w = ul.clientWidth || 1;
    var cur = Math.round(ul.scrollLeft / w);
    for (var i = 0; i < items.length; i++) {
      if (i > cur + n) break;
      var im = items[i].querySelector('img[loading="lazy"]');
      if (im) im.setAttribute('loading', 'eager');
    }
  }
  function hook() {
    var ul = document.querySelector('media-gallery .product__media-list');
    if (!ul || ul.__mpnWarm) return;
    ul.__mpnWarm = true;
    var t;
    ul.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(function () { warm(2); place(); }, 80); }, { passive: true });
    ul.addEventListener('touchstart', function () { warm(2); }, { passive: true });
  }
  function start() { hook(); warm(2); setTimeout(function () { warm(99); }, 2500); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
